/**
 * staleAcceptance - Reconhece erros de aceite desatualizado (pedido anulado porque as
 * respostas da vistoria mudaram depois de abrir a janela de assinatura).
 *
 * RELEASE: 2026-10-17 v1.0.0 - Versão inicial.
 */

/** Mensagem exibida quando o aceite precisa ser refeito sobre o conteúdo novo. */
export const STALE_ACCEPTANCE_MESSAGE = 'A vistoria foi atualizada. Confira e assine novamente.';

/** true quando o servidor recusou porque o pedido/participante não vale mais. */
export function isStaleAcceptanceError(message: string | null | undefined): boolean {
  const m = (message ?? '').toLowerCase();
  return m.includes('participante inválido ou já confirmado')
    || m.includes('as respostas mudaram')
    || m.includes('solicitação de aceite invalidada')
    || m.includes('solicitação de aceite não está aberta');
}
